import styled from "styled-components";

const TitleModalStyled = styled.h4`
  margin: 0;
  line-height: 1.42857143;
  font-weight: bold;
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
`;
const SubtitleModalStyled = styled.span`
  word-wrap: break-word;
`;

export { TitleModalStyled, SubtitleModalStyled };
